// extracted by mini-css-extract-plugin
export default {"header-container":"Header_header-container__wn0IK","navigation-lang-selection-container":"Header_navigation-lang-selection-container__Y6E2l","scrolled":"Header_scrolled__BZe3z"};